import BlogItemList from "./BlogItemList";
import BlogItemEdit from "./BlogItemEdit";

export default {
    list: BlogItemList,
    edit: BlogItemEdit
};